import { render, staticRenderFns } from "./FHomeAbout.vue?vue&type=template&id=524b7740&scoped=true&"
import script from "./FHomeAbout.vue?vue&type=script&lang=js&"
export * from "./FHomeAbout.vue?vue&type=script&lang=js&"
import style0 from "./FHomeAbout.vue?vue&type=style&index=0&id=524b7740&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b7740",
  null
  
)

export default component.exports